import { BaseLineDelete } from '@/app/components/icons/BaseLineDelete';
import { BaseLineDownload } from '@/app/components/icons/BaseLineDownload';
import { BaseLineEdit } from '@/app/components/icons/BaseLineEdit';
import { BaseLineMove } from '@/app/components/icons/BaseLineMove';
import { BaseLineShare2 } from '@/app/components/icons/BaseLineShare2';
import { ProductLineMark } from '@/app/components/icons/ProductLineMark';

export type FileOperationType = 'mark' | 'download' | 'delete' | 'move' | 'share' | 'rename';

export interface FileOperation {
  id: FileOperationType;
  icon: React.ComponentType<{ className?: string }>;
  showInBatch?: boolean;
  showInContext?: boolean;
  showForFolder?: boolean; // 是否在文件夹上显示该操作
}

export const FILE_OPERATIONS: FileOperation[] = [
  {
    id: 'mark',
    icon: ProductLineMark,
    showInBatch: true,
    showInContext: false,
    showForFolder: false,
  },
  {
    id: 'download',
    icon: BaseLineDownload,
    showInBatch: true,
    showInContext: true,
    showForFolder: false, // 文件夹不支持下载
  },
  {
    id: 'share',
    icon: BaseLineShare2,
    showInBatch: false,
    showInContext: true,
    showForFolder: false, // 文件夹不支持分享
  },
  {
    id: 'move',
    icon: BaseLineMove,
    showInBatch: true,
    showInContext: true,
    showForFolder: true,
  },
  {
    id: 'rename',
    icon: BaseLineEdit,
    showInBatch: false,
    showInContext: true,
    showForFolder: true,
  },
  {
    id: 'delete',
    icon: BaseLineDelete,
    showInBatch: true,
    showInContext: true,
    showForFolder: true,
  },
];

// 获取批量操作配置
export const getBatchOperations = (): FileOperation[] => {
  return FILE_OPERATIONS.filter((op) => op.showInBatch);
};

// 获取右键菜单操作配置
export const getContextOperations = (isBatch: boolean, isFolder: boolean): FileOperation[] => {
  return FILE_OPERATIONS.filter((op) => {
    // 批量操作的情况
    if (isBatch) return op.showInBatch;

    // 必须在右键菜单中显示
    if (!op.showInContext) return false;

    // 如果是文件夹，检查是否支持文件夹操作
    if (isFolder && op.showForFolder === false) return false;

    return true;
  });
};
